import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Has from '../../../component/Permission/Has';
import { Alert } from '../../../component/Alert/Alert';
import RegisterCompanyInformation from "../../../component/RegisterCompany/RegisterCompanyInformation";
import { REGISTER_COMPANIES } from "../../../config/PermissionTypes";
import { registerCompany } from "../../../service/RegisterCompaniesService";
import _ from 'lodash';
import "./Register.css";

export default function RegisterCompany(props) {
    const [company, setCompany] = useState({
        companyName: "",
        companyNumber: ""
    })
    const [errors, setErrors] = useState({});
    const [savePending, setSavePending] = useState(false);
    const [banner, setBanner] = useState({
        show: false,
        type: "success",
        message: ""
    });

    function handleCompanyUpdate(field, value) {
        let updatedCompany = { ...company };
        updatedCompany[field] = value
        setCompany(updatedCompany);
    }

    const isSaveDisabled = () => {
        const errorsExist = !_.isEmpty(errors);
        return !company.companyName || !company.companyName.replace(/\s/g, '').length || !company.companyNumber || errorsExist || savePending;
    }

    const showBanner = (type, message) => {
        setBanner({
            show: true,
            type: type,
            message: message
        })
    }

    const handleSaveCompany = async () => {
        setSavePending(true);
        await Promise.resolve(registerCompany(company))
            .then(() => {
                let message = <>The company was successfully registered! <Link to={"/system/registerCompanies"}>Back to Registered Companies page</Link></>;
                showBanner("success", message);
                setSavePending(false);
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.message) {
                    showBanner("error", error.response.data.message);
                } else {
                    showBanner("error", "An error occurred while trying to save the new company.");
                }
                setSavePending(false);
            });
    }

    return (
        <><Has isPageLevel={true} permission={REGISTER_COMPANIES}>
            <div className="container-fluid add-company-page" data-testid="add-company-page">
                <div className="cb-row page-title-area">
                    <div className="cb-col-xs-8 cb-col-lg-8 page-title">
                        <h1 data-testid="add-company-page-header-title">Register Company</h1>
                    </div>
                </div>

                <>{banner.show &&
                    <Alert type={`${banner.type}`} handleOnClose={() => setBanner({ show: false, message: "" })} dataTestId='edit-company-notification'>
                        < div style={{ fontWeight: '500' }}>{banner.message}</div>
                    </Alert>}

                    <div className="company-info-container" data-testid="company-info-fields">
                        <div className="sectionTitle">New Company Information</div>
                        <RegisterCompanyInformation
                            companyName={company.companyName}
                            companyNumber={company.companyNumber}
                            errors={errors}
                            setErrors={setErrors}
                            handleFieldUpdate={handleCompanyUpdate}
                        />
                    </div>

                    <div className="company-buttons" data-testid="add-company-buttons">
                        <Link to={"/system/registerCompanies"}>
                            <button
                                type="button"
                                className="cb-btn cb-btn-outline-secondary"
                                data-testid="add-company-cancel"
                                disabled={false}
                                onClick={() => null}>
                                Cancel
                            </button>
                        </Link>
                        <button
                            className="cb-btn cb-btn-primary"
                            data-testid="add-company-submit"
                            disabled={isSaveDisabled()}
                            onClick={() => handleSaveCompany()}
                        >
                            Register Company
                        </button>
                    </div>
                </>
            </div>
        </Has ></>
    )
}